module.exports = __webpack_public_path__ + "img/icon-twitter.d0b5673e.svg";